import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import "./EducationComponent.css";

class Education extends Component {
  render() {
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <div className="basic-education">
          <div className="education-content-row">
            <div className="education-content-col">
              <Educations theme={this.props.theme} />
            </div>
            <div className="education-content-col">
              <Certifications theme={this.props.theme} />
            </div>
          </div>
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Education;
